import { CreateChatCompletionRequest } from "@mirage/service-dbx-api/service/grpc/ml_capabilities_apiv2/gen/api_v2_pb";
import {
  ApiKey,
  ChatDialog,
  ChatMessage,
  KeyProvider,
  ModelInfo,
} from "@mirage/service-dbx-api/service/grpc/ml_capabilities_apiv2/gen/common_pb";

const modelSourcesToSecretSauceKeys = {
  openai: "DASH_STACK_ITEM_SUMMARIZATION_OPENAI",
};

interface ModelConfig {
  maxTokens: number;
  reservedTokens: number;
  temperature: number;
}

interface ModelConfigurations {
  [key: string]: ModelConfig;
}

const modelConfigs: ModelConfigurations = {
  "gpt-3.5-turbo-0125": {
    maxTokens: 16385,
    reservedTokens: 500,
    temperature: 0,
  },
  "gpt-4o": {
    maxTokens: 128000,
    reservedTokens: 500,
    temperature: 0,
  },
  "llama-v3-70b-instruct": {
    maxTokens: 8192,
    reservedTokens: 500,
    temperature: 0.00001,
  },
  "llama3-70b-8192": {
    maxTokens: 8192,
    reservedTokens: 500,
    temperature: 0.00001,
  },
};

export function getChatCompletionRequest(
  model: string,
  modelSource: string,
  feature: string,
  messages: ChatMessage[],
): CreateChatCompletionRequest {
  const apiKey = new ApiKey({
    key: modelSourcesToSecretSauceKeys[
      modelSource as keyof typeof modelSourcesToSecretSauceKeys
    ],
    provider: KeyProvider.SECRET_SAUCE,
  });

  return new CreateChatCompletionRequest({
    modelInfo: new ModelInfo({ modelName: model, modelSource: modelSource }),
    dialogs: [
      new ChatDialog({
        messages: messages,
      }),
    ],
    capabilitiesConfig: {
      feature: feature,
      apiKey: apiKey,
    },
    modelParams: {
      max_new_tokens: {
        configType: {
          case: "int32Config",
          value: modelConfigs[model].reservedTokens,
        },
      },
      temperature: {
        configType: {
          case: "floatConfig",
          value: modelConfigs[model].temperature,
        },
      },
    },
  });
}
